import { Injectable } from '@angular/core';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { CarrierVettingService } from '@service/carrier-vetting/carrier-vetting.service';
import { CarrierService } from '@service/carrier/carrier.service';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { INTEGRATION_TYPE, RestService } from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class RMISService {
	constructor(
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService,
		private carrierVettingService: CarrierVettingService,
		private carrierService: CarrierService
	) {}

	inviteCarrier(
		carrierId: string,
		brokerAccountId: number,
		brokerUserId: number,
		byBroker = true,
		availableLoad: any = null
	) {
		const url = this.urlService.inviteRMISCarrier(carrierId, brokerAccountId, brokerUserId);
		this.restService.POST(url, {}).subscribe({
			next: () => {
				if (byBroker) {
					this.utilService.showSnackbar(
						'Successfully invited carrier',
						SNACKBAR.SUCCESS,
						SNACKBAR.ACTION
					);
					this.carrierVettingService.carrierInvitationSent(carrierId);
					return;
				}
				this.utilService.showSnackbar(
					"We've started onboarding you to the broker's network.",
					SNACKBAR.SUCCESS,
					SNACKBAR.ACTION
				);
				this.carrierService.carrierRequestedOnboarding(
					carrierId,
					brokerAccountId,
					brokerUserId,
					INTEGRATION_TYPE.RMIS,
					availableLoad
				);
			},
			error: (error) => {
				const message = error['error'] || 'Unable to invite carrier';
				this.utilService.showSnackbar(message, SNACKBAR.ERROR, SNACKBAR.ACTION);
			},
		});
	}
}
